module.exports = __webpack_public_path__ + "static/img/type_icon.df49ff8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/type_icon.jpg
// module id = sT6g
// module chunks = 2